import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import axios from "../../config/AxiosConfig";
import {
  DASHBOARD_PENDING_ACTION_API,
  DASHBOARD_STATISTIC_CHART_API,
  EQUITY_API,
} from "../../store/actions/apiCollections";

const getStatisticChartDataFetcher = (url) =>
  axios.get(url).then((response) => response?.data?.data);

export const useGetStatisticChartData = (languageId, year) => {
  const { data, isValidating, mutate } = useSWR(
    `${DASHBOARD_STATISTIC_CHART_API}${languageId}?year=${year}`,
    getStatisticChartDataFetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
    }
  );

  return { data, isValidating, mutate };
};

const getPendingActionsDataFetcher = (url) =>
  axios.get(url).then((response) => response?.data?.data);

export const useGetPendingActions = (limit, type = "all", search = "") => {
  // Build query params
  const params = new URLSearchParams();
  params.append("limit", limit * 10);
  params.append("type", type);
  if (search) {
    params.append("search", search);
  }

  const { data, isValidating, mutate } = useSWR(
    `${DASHBOARD_PENDING_ACTION_API}?${params.toString()}`,
    getPendingActionsDataFetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
    }
  );

  return { data, isValidating, mutate };
};

const postCalculateDividendShareAmountFetcher = (url, { arg }) => {
  const res = axios
    .post(`${url}${arg?.campaignId}/calculate-per-share-amount`, arg)
    .then((response) => response.data.data);
  return res;
};

export const useCalculateDividendShareAmount = () => {
  const {
    data: calculateDividendShareAmount,
    trigger: calculateDividendShareAmountTrigger,
    isMutating: calculateDividendShareAmountMutating,
    error: calculateDividendShareAmountError,
  } = useSWRMutation(
    `admin/repayment/`,
    postCalculateDividendShareAmountFetcher
  );

  return {
    calculateDividendShareAmount,
    calculateDividendShareAmountTrigger,
    calculateDividendShareAmountMutating,
    calculateDividendShareAmountError,
  };
};
